import { TextInput as WalrusTextInput, style } from '@do/walrus';
import styled from 'styled-components';
import errorIcon from '../../assets/newBrandDesign/error-icon.svg';
import newBrandDesignVars from './overwrite-vars.scss';

const NewTextInput = styled(WalrusTextInput)`
  && {
    margin-top: ${style.vars.whitespace.regular};
    font-size: 1rem;
    line-height: 1.5rem;

    label {
      color: ${newBrandDesignVars.primary};
      font-size: 1rem;
      text-transform: lowercase;

      & span {
        color: ${newBrandDesignVars.red_dark};
      }
    }

    input {
      border: ${style.vars.borderWidth.thin} solid #8794b0;
      border-radius: ${newBrandDesignVars.border_radius_large};
      background: ${newBrandDesignVars.white};
      box-sizing: border-box;
    }
  }

  &.is-invalid input {
    border-color: ${newBrandDesignVars.red_dark} !important;
  }

  &.is-invalid svg {
    display: none;
  }

  &.is-invalid > :last-child::before {
    content: url("${errorIcon}");
    margin-right: ${style.vars.whitespace.xsmall};
    height: ${style.vars.height.xsmall};
  }

  &.is-invalid > :last-child > div {
    font-size: ${style.vars.fontSize.small};
    line-height: ${style.vars.height.xsmall};
    color: ${newBrandDesignVars.red_darkest};
    font-weight: ${style.vars.fontWeight.base};
  }
`;

export default NewTextInput;
